
import { useTheme } from '../theme/ThemeContext';
import { buttonThemes as lightButtonThemes, iconThemes as lightIconThemes, modalThemes as lightModalThemes } from './LightThemeVariables';

/**
 * Hook to get theme-aware button themes
 * Components should use this instead of importing buttonThemes directly
 */
export const useButtonThemes = () => {
  const { buttonThemes } = useTheme();
  return buttonThemes;
};

/**
 * Hook to get theme-aware icon themes
 * Components should use this instead of importing iconThemes directly
 */
export const useIconThemes = () => {
  const { iconThemes } = useTheme();
  return iconThemes;
};

/**
 * Hook to get theme-aware modal themes
 * Components should use this instead of importing modalThemes directly
 */
export const useModalThemes = () => {
  const { modalThemes } = useTheme();
  return modalThemes;
};

// Legacy exports for backward compatibility
// These will use light theme values by default for components that haven't been updated yet
export const buttonThemes = lightButtonThemes;
export const iconThemes = lightIconThemes;
export const modalThemes = lightModalThemes;
